import React, { MouseEvent } from 'react';

interface Props {
  className?: string;
  onClick?: (event: MouseEvent<Element>) => void;
}

const AreaIcon = ({ className, onClick }: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" className={className} onClick={onClick}>
      <path fill="currentColor" d="M0 10V8H2V10H0ZM0 6V4H2V6H0ZM0 2V0H2V2H0ZM4 2V0H6V2H4ZM8 18V16H10V18H8ZM8 2V0H10V2H8ZM12 18V16H14V18H12ZM16 18V16H18V18H16ZM16 14V12H18V14H16ZM16 10V8H18V10H16ZM16 6V2H12V0H18V6H16ZM0 18V12H2V16H6V18H0Z"/>
    </svg>
  );
};

export default AreaIcon;
